// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "../style/Reports.css";
 
// import Finance from "../assets/images/i/Finance  Taxation.jpg";
// import Upstream from "../assets/images/i/Upstream.jpg";
// import Downstream from "../assets/images/i/Downstream.jpg";
// import NaturalGas from "../assets/images/i/Natural Gas.jpg";
// import Sustainability from "../assets/images/i/Sustainability  environment.jpg";
// import EconomicPolicy from "../assets/images/i/economic policy.jpg";
// import PreBudgetMemo from "../assets/images/i/pre budget memorandum.jpg";

// const Reports = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="recommendation-page">
//       {/* ===== TOP ROW : BACK BUTTON ===== */}
//       <div className="top-bar">
//         <button className="back-btn" onClick={() => navigate(-1)}>
//           ← Back
//         </button>
//       </div>

//       {/* ===== CARD GRID ===== */}
//       <div className="card-grid">
//  <div
//           className="card"
//           onClick={() =>
//             window.open("https://www.fipi.org.in/recomm-upstream.php", "_blank")
//           }
//           style={{ cursor: "pointer" }}
//         >
//           <img src={Upstream} alt="Upstream" />
//           <h3>Upstream</h3>
         
//           <div className="card-link">
//             <a href="#!" onClick={(e) => e.preventDefault()}>
//               Explore More Contents
//             </a>
//           </div>
//         </div>
//         {/* Downstream */}
//         <div
//           className="card"
//           onClick={() =>
//             window.open("https://www.fipi.org.in/recomm-downstream.php", "_blank")
//           }
//           style={{ cursor: "pointer" }}
//         >
//           <img src={Downstream} alt="Downstream" />
//           <h3>Downstream</h3>
        
//           <div className="card-link">
//             <a href="#!" onClick={(e) => e.preventDefault()}>
//               Explore More Contents
//             </a>
//           </div>
//         </div>

//                 <div
//           className="card"
//           onClick={() =>
//             window.open("https://www.fipi.org.in/recomm-naturalgas.php", "_blank")
//           }
//           style={{ cursor: "pointer" }}
//         >
//           <img src={NaturalGas} alt="Natural Gas" />
//           <h3>Natural Gas</h3>
//           {/* <div className="card-content">
//             <ul>
//               <li>Gas Pricing & Allocation Policy</li>
//               <li>Infrastructure & Pipeline Network</li>
//               <li>City Gas Distribution (CGD)</li>
//             </ul>
//           </div> */}
//           <div className="card-link">
//             <a href="#!" onClick={(e) => e.preventDefault()}>
//               Explore More Contents
//             </a>
//           </div>
//         </div>



//                 <div
//           className="card"
//           onClick={() =>
//             window.open("https://www.fipi.org.in/recomm-naturalgas.php", "_blank")
//           }
//           style={{ cursor: "pointer" }}
//         >
//           <img src={EconomicPolicy} alt="Economic Policy" />
//           <h3>Economic Policy</h3>
         
//           <div className="card-link">
//             <a href="#!" onClick={(e) => e.preventDefault()}>
//               Explore More Contents
//             </a>
//           </div>
//         </div>

//         {/* Finance & Taxation */}
//         <div
//           className="card"
//           onClick={() =>
//             window.open("https://www.fipi.org.in/recomm-finance.php", "_blank")
//           }
//           style={{ cursor: "pointer" }}
//         >
//           <img src={Finance} alt="Finance and Taxation" />
//           <h3>Finance and Taxation</h3>
          
//           <div className="card-link">
//             <a href="#!" onClick={(e) => e.preventDefault()}>
//               Explore More Contents
//             </a>
//           </div>
//         </div>

       
//         <div
//           className="card"
//           onClick={() =>
//             window.open("https://www.fipi.org.in/recomm-naturalgas.php", "_blank")
//           }
//           style={{ cursor: "pointer" }}
//         >
//           <img src={Sustainability} alt="Sustainability & Environment" />
//           <h3>Sustainability & Environment</h3>
         
//           <div className="card-link">
//             <a href="#!" onClick={(e) => e.preventDefault()}>
//               Explore More Contents
//             </a>
//           </div>
//         </div>

//                 <div
//           className="card"
//           onClick={() =>
//             window.open("https://www.fipi.org.in/recomm-naturalgas.php", "_blank")
//           }
//           style={{ cursor: "pointer" }}
//         >
//           <img src={PreBudgetMemo} alt="Pre-Budget Memorandum" />
//           <h3>Pre-Budget Memorandom</h3>
        
//           <div className="card-link">
//             <a href="#!" onClick={(e) => e.preventDefault()}>
//               Explore More Contents
//             </a>
//           </div>
//         </div>


//         {/* Natural Gas – centered */}
//         {/* <div className="card card-center"> */}

//       </div>
//     </div>
//   );
// };

// export default Reports;

import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/FipiPublication.css";

import Finance from "../assets/images/i/Finance  Taxation.jpg";
import Upstream from "../assets/images/i/Upstream.jpg";
import Downstream from "../assets/images/i/Downstream.jpg";
import NaturalGas from "../assets/images/i/Natural Gas.jpg";
import Sustainability from "../assets/images/i/Sustainability  environment.jpg";
import EconomicPolicy from "../assets/images/i/economic policy.jpg";
import PreBudgetMemo from "../assets/images/i/pre budget memorandum.jpg";

const Reports = () => {
  const navigate = useNavigate();

  return (
    <div className="fipi-publication">

      {/* Back Button */}
      <div className="fipi-publication-header">
        <button className="clear-filters-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>

      {/* Grid */}
      <div className="fipi-publication-grid">

        <div className="card" onClick={() => window.open("https://www.fipi.org.in/upstream.php","_blank")}>
          <img src={Upstream} alt="Upstream" />
          <h3>Upstream</h3>
          <div className="card-link "> <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents</a></div>
        </div>

        <div className="card" onClick={() => window.open("https://www.fipi.org.in/downstream-report.php","_blank")}>
          <img src={Downstream} alt="Downstream" />
          <h3>Downstream</h3>
          <div className="card-link"> <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents</a></div>
        </div>

        <div className="card" onClick={() => window.open("https://www.fipi.org.in/gas.php","_blank")}>
          <img src={NaturalGas} alt="Natural Gas" />
          <h3>Natural Gas</h3>
          <div className="card-link"> <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents</a></div>
        </div>

        <div className="card" onClick={() => window.open("https://www.fipi.org.in/e-p.php","_blank")}>
          <img src={EconomicPolicy} alt="Economic Policy" />
          <h3>Economic Policy</h3>
          <div className="card-link"> <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents</a></div>
        </div>

        <div className="card" onClick={() => window.open("https://www.fipi.org.in/taxation.php","_blank")}>
          <img src={Finance} alt="Finance and Taxation" />
          <h3>Finance and Taxation</h3>
          <div className="card-link"> <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents</a></div>
        </div>

        <div className="card" onClick={() => window.open("https://www.fipi.org.in/sustanability-report.php","_blank")}>
          <img src={Sustainability} alt="Sustainability & Environment" />
          <h3>Sustainability & Environment</h3>
          <div className="card-link"> <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents</a></div>
        </div>

        <div className="card" onClick={() => window.open("https://www.fipi.org.in/pre-budget-memorandam.php","_blank")}>
          <img src={PreBudgetMemo} alt="Pre-Budget Memorandum" />
          <h3>Pre-Budget Memorandum</h3>
          <div className="card-link"> <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents</a></div>
        </div>

      </div>
    </div>
  );
};

export default Reports;

